import { Fragment, useContext, useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import CustomizerContext from '../../../../_helper/Customizer';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { SalutationApi } from '../../../../api';
import { toast } from 'react-toastify';
import CardRibbonWithForm from '../../../Common/Component/CardRibbonWithForm';
import { base_form_fields3, createDropdownField } from '../../../../Data/FormField/PublicData';
import { code_field } from '../../../../Data/FormField/PublicData';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import { AccountName, AccountNumber, BankName } from '../../../../Constant';
import { CaseCategoryApi } from '../../../../api';

const BankPaymentInfo = () => {
  const history = useNavigate();
  const axiosPrivate = useAxiosPrivate()
  const { layoutURL } = useContext(CustomizerContext);
  const lists = `${process.env.PUBLIC_URL}/crm/settings/issue-group/${layoutURL}`;
  const [formFields, setFormFields] = useState(base_form_fields3(`${AccountName}`));
  const [isNewFieldAdded, setIsNewFieldAdded] = useState(false);




  const { formState: { errors }, } = useForm();


  const BankDropDown = createDropdownField(axiosPrivate,
    'case_category_id',
    'case_category_id',
    `${BankName}`,
    `${CaseCategoryApi}`,
    '', 12
  );

  useEffect(() => {

    const fetchData = async () => {
      try {
        if (!isNewFieldAdded) {

          const updatedFields = [BankDropDown, code_field(`${AccountNumber}`), ...formFields];
          

          await updatedFields[0].fetchOptions();

          setFormFields(updatedFields);
          setIsNewFieldAdded(true);
        }
      } catch (error) {
        //console.error('Error fetching options:', error);
      }
    };

    fetchData();
  }, [formFields, isNewFieldAdded, BankDropDown, code_field]);


  const addNewRecord = async (newRecord) => {
    if (newRecord === '') {
      errors.showMessages();
    }

    const newRecordTemp = {
      name: newRecord.name,
      description: newRecord.name,
      is_active: newRecord.is_active,
      //file: newRecord.file[0]
    };

    try {
      await axiosPrivate.post(SalutationApi, newRecordTemp, {
        headers: {
          //'Content-Type': 'multipart/form-data',
          'Content-Type': 'application/json',
        },
      }).then((resp) => {
        toast.success(`${resp.data.name} is successfully added.`)
        history(lists);
      });
    } catch (error) {
      if (error.response && error.response.status === 422) {
        toast.error('Validation Errors');
      } else if (error.response && error.response.status === 400) {
        toast.error(error.response.data.detail);
      }
      else {
        toast.error('Form submission error');
      }
      throw error;
    }
  };

  /*   const getUploadParams = ({ meta }) => {
      return {
        url: 'http://localhost:8001/public-data/upload',
      };
    };
  
    // called every time a file's `status` changes
    const handleChangeStatus = ({ meta, file }, status) => {}; */

  return (
    <Fragment>
      <Breadcrumbs parent="HRM" title="Bank Payment Info " mainTitle="Bank Payment Info" />
      <Container fluid={true}>
        <Row>
          <Col sm='10'>
            <CardRibbonWithForm formFields={formFields} onSubmit={addNewRecord} ribbonUrl={lists} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default BankPaymentInfo;